import apiClient from './api.service';
import type { LegalConsentStatus, PublicLegalDocument, RegisterLegalConsentRequest } from '../types/legalConsent.types';

class LegalConsentService {
  async getStatus(): Promise<LegalConsentStatus> {
    const response = await apiClient.get<{ data: LegalConsentStatus }>('/api/legal/consent/status');
    return response.data.data;
  }

  async registerConsent(payload: RegisterLegalConsentRequest) {
    const response = await apiClient.post<{ data: unknown }>('/api/legal/consents', payload);
    return response.data.data;
  }

  async getPublicTerms(version?: string): Promise<PublicLegalDocument | null> {
    const response = await apiClient.get<{ data: PublicLegalDocument }>('/api/public/legal/terms-of-service', {
      params: version ? { version } : undefined,
    });
    return response.data.data;
  }

  async getPublicPrivacyPolicy(version?: string): Promise<PublicLegalDocument | null> {
    const response = await apiClient.get<{ data: PublicLegalDocument }>('/api/public/legal/privacy-policy', {
      params: version ? { version } : undefined,
    });
    return response.data.data;
  }

  async getPublicCookiePolicy(version?: string): Promise<PublicLegalDocument | null> {
    const response = await apiClient.get<{ data: PublicLegalDocument }>('/api/public/legal/cookie-policy', {
      params: version ? { version } : undefined,
    });
    return response.data.data;
  }
}

export const legalConsentService = new LegalConsentService();
